module.exports = __webpack_public_path__ + "static/img/27_pro.8bbcf25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/27_pro.jpg
// module id = S80x
// module chunks = 0